import { useBackend } from "../../services";

export const useUpdateApplePayments = () => {
  const { post } = useBackend();
  return async () => post("admin/updateApplePayments", {});
};
